(window as any).CONFIG = {
    api_url: "/api/",
    time_check_changes_guests: 120000,
    PROJECT_CODE: "8bc22d49-d650-4b41-9f9c-3120ca3fca72",
    version_info_url: "https://itsm.diaple.com/api/",
};

(window as any).CONFIG_TINYMCE = {

    no_company_id  : {
        font_color_description: "grey",
        font_size: "12px",
        font_family: "tahoma,arial,helvetica,sans-serif"
    },
    company_id_1  : {
        font_color_description: "red",
        font_size: "14px",
        font_family: "tahoma,arial,helvetica,sans-serif"
    },
    company_id_3  : {
        font_color_description: "red",
        font_size: "14px",
        font_family: "tahoma,arial,helvetica,sans-serif"
    },
    company_id_4: {
        font_color_description: "red",
        font_size: "14px",
        font_family: "tahoma,arial,helvetica,sans-serif"
    },
    company_id_5: {
        font_color_description: "red",
        font_size: "14px",
        font_family: "tahoma,arial,helvetica,sans-serif"
    },
    company_id_6: {
        font_color_description: "grey",
        font_size: "14px",
        font_family: "tahoma,arial,helvetica,sans-serif"
    },
    company_id_7: {
        font_color_description: "red",
        font_size: "14px",
        font_family: "tahoma,arial,helvetica,sans-serif"
    }

};

import "jquery-ui/ui/widgets/datepicker";
import "icheck";
import "bootstrap";
import "fabric";
import 'angular';
import '@angular/compiler';
import * as ace from "ace-builds/src-noconflict/ace";
(window as any).ace = ace;
/*import "ace-builds/src-noconflict/mode-sqlserver";
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/mode-json";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/theme-twilight";
import "ace-builds/src-noconflict/theme-sqlserver";
import "ace-builds/webpack-resolver";*/
import "html2canvas";
import "toastr";

import * as tinymce from './editor';

import * as CryptoJS from 'crypto-js';

import "./scripts/inspinia";
import "./scripts/angularjs-chips";
import "angular-ui-bootstrap";

// Export pdf

var pdfMake = require('pdfmake/build/pdfmake.js');
var pdfFonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.vfs = pdfFonts.pdfMake.vfs;


//Export excel
var ExcelBuilder = require('excel-builder-webpacker');
(window as any).ExcelBuilder = ExcelBuilder;



import html2canvas from "html2canvas";

import * as _ from 'lodash';

import "@ui-grid/core/dist/ui-grid.core";
import "@ui-grid/selection/dist/ui-grid.selection";
import "@ui-grid/exporter/dist/ui-grid.exporter";
import "@ui-grid/pagination/dist/ui-grid.pagination";
import "@ui-grid/tree-base/dist/ui-grid.tree-base";
import "@ui-grid/tree-view/dist/ui-grid.tree-view";
import "@ui-grid/auto-resize/dist/ui-grid.auto-resize";
import "@ui-grid/edit/dist/ui-grid.edit";
import "@ui-grid/cell-nav/js/ui-grid.cellnav";
import "@ui-grid/expandable/dist/ui-grid.expandable";

import "angular-ui-router";
import "angular-ui-bootstrap";
import "angular-ui-tree";

import "angular-ui-calendar";
import "angular-ui-validate";
import "angular-ui-date";
import "angular-ui-sortable";
import "angular-ui-slider";
import "angular-ui-ace";
import "angular-gantt";
import "angular-gantt/assets/angular-gantt-plugins";
import "angular-moment";
import "angular-animate";
import "ui-iconpicker/dist/scripts/ui-iconpicker";

import "restangular";
import "ng-log-unobtrusive-extension";
import "angular-filter";

import "angular-sanitize";
import "ui-select";
import "angular-translate";
import "angular-translate/dist/angular-translate-loader-url/angular-translate-loader-url"
import "angular-bootstrap-colorpicker";
import "angular-bootstrap-contextmenu";
import "angular-ui-tinymce";
import "ng-flow/dist/ng-flow-standalone.js";
import "ng-file-upload";
import "angular-clipboard";
import "angular-ui-switch";
import "angular-media-queries";

import "fullcalendar";
import { Chart } from 'chart.js';

import "moment";

import toastr from "toastr";
import Bee from '@beefree.io/sdk';

import "encoding-japanese";
import "xmltojson";

import "./app";
import "./app.downgraded";
import "./common/services/_index";
import "./app/angularjs/materials/_index";
import "./app/angularjs/notifications/_index";
import "./app/angularjs/common/_index";
import "./app/angularjs/events/_index";
import "./app/angularjs/dashboard/_index";
import "./app/angularjs/dashboard_space/_index";
import "./app/angularjs/users/_index";
import "./app/angularjs/menus/_index";
import "./app/angularjs/companies/_index";
import "./app/angularjs/login/login";
import "./app/angularjs/auth/_index";
import "./app/angularjs/tags/_index";
import "./app/angularjs/authentication_processes/_index";
import "./app/angularjs/authentication_services/_index";
import "./app/angularjs/languages/_index";
import "./app/angularjs/update/_index";
import "./app/angularjs/groups/_index";
import "./app/angularjs/persons/_index";
import "./app/angularjs/political_affiliations/_index";
import "./app/angularjs/staff/_index";
import "./app/angularjs/documents_reports/_index";
import "./app/angularjs/documents_types/_index";
import "./app/angularjs/countries/_index";
import "./app/angularjs/gifts/_index";
import "./app/angularjs/files_types/_index";
import "./app/angularjs/files_types_whitelist/_index";
import "./app/angularjs/events_users_profiles/_index";
import "./app/angularjs/indicators_types/_index";
import "./app/angularjs/persons_information_groups/_index";
import "./app/angularjs/informations/_index";
import "./app/angularjs/reports/tasks_reports/_index";
import "./app/angularjs/restaurants/_index";
import "./app/angularjs/locations_reservations/_index";
import "./app/angularjs/mail_accounts/_index";
import "./app/angularjs/reports/persons_reports/_index";
import "./app/angularjs/reports/gifts_reports/_index";
import "./app/angularjs/reports/resume_reports/_index";
import "./app/angularjs/budget_groups/_index";
import "./app/angularjs/inscriptions_forms/_index";
import "./app/angularjs/identifiers/_index";
import "./app/angularjs/contact_types/_index";
import "./app/angularjs/persons_treatments/_index";
import "./app/angularjs/import_documents/_index";
import "./app/angularjs/razor_views/_index";
import "./app/angularjs/mailings/_index";
import "./app/angularjs/mailings_types/_index";
import "./app/angularjs/passbooks/_index";
import "./app/angularjs/institutions/_index";
import "./app/angularjs/warehouses/_index";
import "./app/angularjs/providers/_index";
import "./app/angularjs/event_hosts/_index";
import "./app/angularjs/cms_categories/_index";
import "./app/angularjs/spaces/_index";
import "./app/angularjs/events_types/_index";
import "./app/angularjs/reports/_index";
import "./app/angularjs/notifications_by_person/_index";
import "./app/angularjs/rgpd/_index";
import "./app/angularjs/templates/_index";
import "./app/angularjs/datasets/_index";
import "./app/angularjs/folders/_index";
import "./app/angularjs/tasks_status/_index";
import "./app/angularjs/tasks_types/_index";
import "./app/angularjs/correspondence/_index";
import "./app/angularjs/correspondences_types/_index";
import "./app/angularjs/tasks/_index";
import "./app/angularjs/annexes/_index";
import "./app/angularjs/accesses/_index";
import "./app/angularjs/audits/_index";
import "./app/angularjs/push_notifications_types/_index";
import "./app/angularjs/push_notifications/_index";
import "./app/angularjs/events_programs_mails/_index";


import "./app/features/common/_index";

import "./common/filters/_index";
import "./common/directives/_index";

import 'bootstrap/dist/css/bootstrap.css';
import 'fullcalendar/dist/fullcalendar.css';
import 'icheck/skins/square/blue.css';
import 'ui-iconpicker/dist/styles/ui-iconpicker.css';
import 'ui-select/dist/select.css';

//@ts-ignore
import "../node_modules/icheck/skins/square/_all.css";

import "./styles/_index";

import './instrument';

import "./app/app.module";



